// extracted by mini-css-extract-plugin
module.exports = {"active":"main-module_active_1C1Mb"};